// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/quotation/style.less
// module id = 2276
// module chunks = 0